import logo_mobile_small from "../../images/logo_mobile.png";

export const captainAlphaWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "INET  Mentor",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Ace your INET exam with expert guidance from AI INET Mentor Anita Deshmukh. Get personalized tips and strategies to boost your score and secure your spot in the Indian Navy!",
  redirectDescription:
    "Arjun Rathore is an AI-driven mentor modeled after the best practices and insights gathered from CDS assessors like Group Testing Officers (GTOs), Interviewing Officers (IOs), and Psychologists. Drawing upon years of experience in CDS evaluations and rigorous training, Capt. Alpha is equipped to guide aspiring candidates in all aspects of CDS preparation.",
  tutorialLink: "https://www.youtube.com/embed/XM8KqEIkXpg",
  startLink: "startQuestion",
};

export const medicalWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Medical Officer",
  tagLine: "Guided by AI Medical Officer Ravinder Yadav",
  description:
    "Prepare for your medicals with guidance from AI  Medical Officer Ravinder Yadav. Get expert advice to ensure you're fully ready for your CDS medicals.",
  redirectDescription:
    "Dr. Ravinder Yadav is an advanced AI-powered medical expert developed to help candidates prepare thoroughly for the medical standards required to join the Indian Armed Forces. With insights from seasoned military doctors, Dr. Yadav provides guidance on everything from fitness standards to specific medical checks, ensuring you’re fully prepared for the medical assessment phase of the selection process.",
  tutorialLink: "",
  startLink: "startMedical",
};

export const physicalWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Fitness Trainer",
  tagLine: "Guided by AI Fitness Trainer Vikram Kumar",
  description:
    "Build your physical fitness for the SSB interview while preparing for the INET exam – train smart, succeed faster!",
  redirectDescription:
    "Vikram Kumar is a cutting-edge AI fitness trainer developed to guide you through the physical challenges of the CDS selection process. With an in-depth understanding of the physical standards required in the Indian Armed Forces, Vikram delivers personalized workout programs, diet plans, and mental toughness exercises to help you build the stamina, strength, and endurance needed to succeed.",
  tutorialLink: "https://www.youtube.com/embed/DuxI7Yze6Wk?si=Wwi7q6wA_uGtavo2",
  startLink: "startPhysical",
};

export const spokenEnglishWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Spoken English",
  tagLine: "Guided by AI English trainer Mark",
  description:
    "Master Spoken English with Mark – start practicing today and build the confidence you need for SSB recommendation, all while preparing for your INET written exam.",
  redirectDescription:
    "Mark is a state-of-the-art AI language trainer designed to help CDS aspirants develop clear, confident, and effective English communication skills. Tailored to meet the needs of CDS interviews, Mark focuses on improving vocabulary, pronunciation, fluency, and confidence, helping you make a strong impression.",
  tutorialLink: "",
  startLink: "startSpokenEnglish",
};

export const currentAffairsWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Current Affairs",
  tagLine: "Guided by AI CDS Mentor Captain Alpha",
  description:
    "No need to browse through multiple newspapers and magazines—stay updated on current affairs with AI INET Mentor Anita Deshmukh, your one-stop solution for INET prep.",
  tutorialLink: "",
  startLink: "startCurrentAffairs",
};

export const coursesWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Courses",
  tagLine: "By DIPR Trained officers",
  description:
    "Enroll in INET courses by expert teachers — available both online and offline — exclusively on the Alpha Regiment website.",
  tutorialLink: "",
  startLink: "startCourses",
};

export const generalScienceWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "General Science",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now master General Science for your INET exam with AI INET Mentor Anita Deshmukh – smart learning, guaranteed results!",
  tutorialLink: "",
  startLink: "startGeneralScience",
};

export const reasoningWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Reasoning",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now supercharge your Reasoning preparation for the INET exam with AI INET Mentor Anita Deshmukh – train your mind to think smart, solve fast, and succeed with confidence!",
  tutorialLink: "",
  startLink: "startReasoning",
};

export const histroyWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "History",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now boost your History preparation for the INET exam with AI INET Mentor Anita Deshmukh – learn the past to secure your future!",
  tutorialLink: "",
  startLink: "startHistory",
};

export const geographyWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Geography ",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now strengthen your Geography for the INET exam with AI INET Mentor Anita Deshmukh – learn with clarity, succeed with confidence!",
  tutorialLink: "",
  startLink: "startGeography",
};

// export const physicsWlcmMsg = {
//   logoImg: logo_mobile_small,
//   name: "Physics",
//   tagLine: "Guided by AI INET Mentor Anita Deshmukh",
//   description:
//     "Now power up your Physics preparation for the CDS exam with AI CDS Mentor Arjun Rathore – understand concepts, crack questions with ease!",
//   tutorialLink: "",
//   startLink: "startPhysics",
// };

export const mathsWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Maths",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now sharpen your Maths for the INET exam with AI INET Mentor Anita Deshmukh – practice smart, solve faster, and score higher!",
  tutorialLink: "",
  startLink: "startMaths",
};

export const englishWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "English",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now boost your English preparation for the INET exam with AI INET Mentor Anita Deshmukh – improve grammar, vocabulary, and comprehension the smart way!",
  tutorialLink: "",
  startLink: "startEnglish",
};

export const polityWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "Polity",
  tagLine: "Guided by AI INET Mentor Anita Deshmukh",
  description:
    "Now strengthen your Polity preparation for the INET exam with AI INET Mentor Anita Deshmukh – grasp the Constitution, governance, and current affairs with clarity and confidence!",
  tutorialLink: "",
  startLink: "startPolity",
};

export const ssbWlcmMsg = {
  logoImg: logo_mobile_small,
  name: "SSB GPT",
  tagLine: "SSB Interview self-preparation tool",
  description:
    "Now get ready for your SSB interview with SSB-GPT – your smart companion for success!",
  tutorialLink: "",
  startLink: "startPolity",
};
